// import Swiper from 'swiper'
export default () => {
	window.elementorFrontend.hooks.addAction(
		'frontend/element_ready/visa-testimonial.default',
		function ($element) {
			const eleSwiper = $('.testimonials-swiper', $element)
			if (eleSwiper.length) {
				const sliderConfig = eleSwiper.data('slider')
				const asyncSwiper = window.elementorFrontend.utils.swiper //using swiper of elementor
				
				let breakpointMobile = {
					slidesPerView: sliderConfig?.slides_per_view_mobile || 1,
					spaceBetween: sliderConfig?.space_between_mobile || 12,
				}
				
				let breakpointTablet = {
					slidesPerView: sliderConfig?.slides_per_view_tablet || 2,
					spaceBetween: sliderConfig?.space_between_tablet || 12,
				}
				
				let breakpointDesktop = {
					slidesPerView: sliderConfig?.slides_per_view || 2,
					spaceBetween: sliderConfig?.space_between || 16,
				}
				
				new asyncSwiper(eleSwiper, {
					loop: true,
					breakpoints: {
						// when window width is >= 320px
						320: breakpointMobile,
						// when window width is >= 640px
						640: breakpointTablet,
						// when window width is >= 992px
						1000: breakpointDesktop,
					},
					// Navigation arrows
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				})
			}
		}
	)
}
